import React, { useEffect } from 'react'
import { selectAddressWithoutVDEKeywords, selectItineraryKeywords } from '../../store/ad/ad.selectors'
import { TAG_CLOSE_AD_BANNER } from '../analytics/analytics.tagids.constants'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import { withOnlyGE } from '../Device'
import encircledCross from '../genericComponents/assets/encircled_cross.svg'
import SVGIcon from '../svg/SVGIcon'
import useUIDisplay from '../ui/useUIDisplay'
import useEventCallback from '../utils/useEventCallback'
import AdLoader from './AdLoader'
import s from './FloatingDesktopAdBanner.less'
import { useSelector } from 'react-redux'

const FloatingDesktopAdBanner = withOnlyGE(({ adName, keywordsSelector }) => {
  const configureAndSendTag = useConfigureAndSendTag()
  const { isUIDisplayed, showUI, hideUI } = useUIDisplay(UI_ELEMENTS.AD_BANNER)
  const keywords = useSelector(keywordsSelector)

  const onClose = useEventCallback(() => {
    hideUI()
    configureAndSendTag({
      type: TAG_CLOSE_AD_BANNER,
    })
  }, [hideUI])

  useEffect(() => {
    if (keywords !== null) {
      showUI()
      return () => hideUI()
    }
  }, [keywords])

  if (!isUIDisplayed) return <></>

  return (
    <div className={s.container}>
      <AdLoader
        adName={adName}
        keywordsSelector={keywordsSelector}
        className={s.content}
        placeHolder={{ height: 90, width: 728 }}
      />
      <button className={s.closeButton} onClick={onClose}>
        <SVGIcon url={encircledCross} inlineSvg />
      </button>
    </div>
  )
})

export const AdDesktopBannerItineraryResult = () => (
  <FloatingDesktopAdBanner adName="itinerary_results_banner_desktop" keywordsSelector={selectItineraryKeywords} />
)

export const AdDesktopBannerAddressResult = () => (
  <FloatingDesktopAdBanner adName="address_banner_desktop" keywordsSelector={selectAddressWithoutVDEKeywords} />
)
